import {
  GET_SOFTSKILLS_COURSES,
  GET_SOFTSKILLS_COURSES_SUCCESS,
  GET_SOFTSKILLS_COURSES_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  courses: [],
}

const SoftskillsCoursesList = (state = initialState, action) => {
  switch (action.type) {
    case GET_SOFTSKILLS_COURSES:
      state = {
        ...state,
        loading: true,
      }
      break
    case GET_SOFTSKILLS_COURSES_SUCCESS:
      state = {
        ...state,
        courses: action.payload.courses,
        loading: false,
        done: true,
      }
      break
    case GET_SOFTSKILLS_COURSES_ERROR:
      state = { ...state, error: action.payload, loading: false, done: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default SoftskillsCoursesList
